import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";

const SatisfactionRating = () => {
  const [rating, setRating] = useState("");
  const [maxRating, setMaxRating] = useState("");
  const [responses, setResponses] = useState("");

  const [editingRating, setEditingRating] = useState(false);
  const [editingMaxRating, setEditingMaxRating] = useState(false);
  const [editingResponses, setEditingResponses] = useState(false);

  // Calculate percentage for visual indicator
  const ratingNum = Number(rating) || 0;
  const maxRatingNum = Number(maxRating) || 7;
  const percentage = maxRatingNum > 0 ? (ratingNum / maxRatingNum) * 100 : 0;

  // Determine color based on rating
  const getRatingColor = () => {
    if (percentage >= 80) return "#16a34a"; // Green - Excellent
    if (percentage >= 60) return "#1a5c99"; // Blue - Good
    if (percentage >= 40) return "#f59e0b"; // Orange - Fair
    return "#dc2626"; // Red - Poor
  };

  const color = getRatingColor();

  return (
    <div
      className="rounded-lg p-4 px-6 bg-white shadow-sm mx-auto max-w-full"
      style={{ border: `2px solid ${color}` }}
    >
      <div className="flex items-center justify-center gap-3 flex-wrap">
        {/* Label */}
        <span
          className="text-lg font-bold tracking-wide uppercase"
          style={{ color: "#144677" }}
        >
          SATISFACTION RATING:
        </span>

        {/* Icon */}
        <FontAwesomeIcon
          icon={faSmile}
          className="text-3xl"
          style={{ color: color }}
        />

        {/* Rating Value - Editable */}
        {editingRating ? (
          <input
            autoFocus
            type="number"
            step="0.01"
            placeholder="0.00"
            value={rating}
            onChange={(e) => setRating(e.target.value)}
            onBlur={() => setEditingRating(false)}
            className="text-3xl font-extrabold w-24 border-none outline-none bg-transparent p-0"
            style={{ color: color }}
          />
        ) : (
          <span
            onClick={() => setEditingRating(true)}
            className={`text-3xl font-extrabold cursor-pointer min-w-[60px] ${
              rating === "" ? "text-gray-300" : ""
            }`}
            style={{ color: rating === "" ? undefined : color }}
          >
            {rating === "" ? "0.00" : rating}
          </span>
        )}

        {/* Separator */}
        <span className="text-3xl font-normal text-gray-500">/</span>

        {/* Max Rating - Editable */}
        {editingMaxRating ? (
          <input
            autoFocus
            type="number"
            step="1"
            placeholder="7"
            value={maxRating}
            onChange={(e) => setMaxRating(e.target.value)}
            onBlur={() => setEditingMaxRating(false)}
            className="text-3xl font-extrabold text-gray-500 w-16 border-none outline-none bg-transparent p-0"
          />
        ) : (
          <span
            onClick={() => setEditingMaxRating(true)}
            className={`text-3xl font-extrabold cursor-pointer min-w-[40px] ${
              maxRating === "" ? "text-gray-300" : "text-gray-500"
            }`}
          >
            {maxRating === "" ? "7" : maxRating}
          </span>
        )}

        {/* Survey Responses - Editable */}
        {editingResponses ? (
          <input
            autoFocus
            type="number"
            placeholder="0"
            value={responses}
            onChange={(e) => setResponses(e.target.value)}
            onBlur={() => setEditingResponses(false)}
            className="text-sm font-semibold text-gray-500 w-16 border-none outline-none bg-transparent ml-2 p-0"
          />
        ) : (
          <span
            onClick={() => setEditingResponses(true)}
            className={`text-sm font-semibold ml-2 cursor-pointer ${
              responses === "" ? "text-gray-300" : "text-gray-500"
            }`}
          >
            {responses === "" ? "0" : responses} survey responses
          </span>
        )}
      </div>

      {/* Progress Bar */}
      <div className="mt-3 w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};
export default SatisfactionRating;
